// @ts-nocheck
import { Plug, Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { AI_AGENT_FIELD_LIMITS } from '@/utilities/constant';
import { getAiAgentDescriptionCharLimit } from '@/utilities/aiAgentAcl';
import { c, Section, Field, Empty, IconBtn, useStudio, useNode, useShown } from '../ui';

const { MCP_SERVERS_MAX_ITEMS: MAX, MCP_NAME_MAX, MCP_URL_MAX } = AI_AGENT_FIELD_LIMITS;

const isValidUrl = (v) => {
  try {
    const u = new URL(v.trim());
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
};
const genId = () => crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export default function McpSection({ next, onNext, value, onChange }) {
  const servers = value || [];
  const { touch } = useStudio();
  const node = useNode('mcp');
  const shown = useShown();
  const descLimit = getAiAgentDescriptionCharLimit();

  const errors = (s) => {
    const e = {};
    const n = (s.name || '').trim();
    const u = (s.url || '').trim();
    const any = n || u;
    if (any && !n) e.name = 'Add a server name.';
    if (any && !u) e.url = 'Add the server URL.';
    if (u && !isValidUrl(u)) e.url = 'Enter a valid URL starting with http:// or https://';
    return e;
  };

  const add = () => {
    if (servers.length >= MAX) {
      toast.error(`You can add up to ${MAX} MCP servers`);
      return;
    }
    onChange([...servers, { id: genId(), name: '', url: '', description: '' }]);
  };
  const update = (id, patch) => onChange(servers.map((s) => (s.id === id ? { ...s, ...patch } : s)));

  const tag = node.bad ? 'attention' : node.ok ? (servers.some((s) => s.name?.trim() && s.url?.trim()) ? 'set' : 'done') : 'optional';

  return (
    <Section
      id="mcp"
      icon={Plug}
      title="MCP servers"
      sub="Connect outside tools the agent can use."
      tag={tag}
      ok={node.ok}
      bad={node.bad}
      next={next('mcp')}
      onNext={onNext}
    >
      <div className={c('cnt')} style={{ margin: '0 0 10px' }}>
        <span>
          {servers.length} of {MAX} servers
        </span>
      </div>
      {servers.map((s, i) => {
        const e = errors(s);
        const show = shown('mcp') || shown(`mcp.${s.id}`);
        return (
          <div className={c('form-card')} key={s.id}>
            <div className={c('fh')}>
              <Plug className="ags-i" /> Server {i + 1}
              <span style={{ marginLeft: 'auto' }}>
                <IconBtn icon={Trash2} danger label={`Remove server ${i + 1}`} onClick={() => onChange(servers.filter((x) => x.id !== s.id))} />
              </span>
            </div>
            <div className={c('row2')}>
              <Field label="Name" required error={show && e.name} count={undefined}>
                <input
                  className={c('ctl', show && e.name && 'invalid')}
                  value={s.name}
                  maxLength={MCP_NAME_MAX}
                  placeholder="e.g. Hotel PMS"
                  onChange={(ev) => update(s.id, { name: ev.target.value })}
                  onBlur={() => touch(`mcp.${s.id}`)}
                />
              </Field>
              <Field label="URL" required error={show && e.url}>
                <input
                  className={c('ctl', show && e.url && 'invalid')}
                  value={s.url}
                  maxLength={MCP_URL_MAX}
                  placeholder="https://mcp.example.com/sse"
                  onChange={(ev) => update(s.id, { url: ev.target.value })}
                  onBlur={() => touch(`mcp.${s.id}`)}
                />
              </Field>
            </div>
            <Field label="Description" optional style={{ margin: 0 }} count={(s.description || '').length} max={descLimit} note="Tells the agent what this server is for.">
              <input
                className={c('ctl')}
                value={s.description || ''}
                maxLength={descLimit}
                placeholder="What this server lets the agent do"
                onChange={(ev) => update(s.id, { description: ev.target.value })}
              />
            </Field>
          </div>
        );
      })}
      {servers.length === 0 && <Empty icon={Plug} title="No servers connected" text="Connect outside tools the agent can use during a call." />}
      <div className={c('addrow')}>
        <button type="button" className={c('btn small')} onClick={add} disabled={servers.length >= MAX}>
          <Plus className="ags-i" />
          Connect a server
        </button>
      </div>
    </Section>
  );
}
